<script setup lang="ts">
import { type Component, onMounted, onBeforeUnmount } from 'vue';
import { AssessmentQuestion } from '../../../../types/assessment';
import Slide from '../../../Animation/Slide.vue';
import QuizFillInBlank from './patterns/QuizFillInBlank.vue';
import QuizMutipleChoice from './patterns/QuizMutipleChoice.vue';
import { audioManager } from '../../../../utils/audioManager';
import { QuestionState, QuizAudioKey } from '../../../../types/quiz';

import quizReview from '../../../../assets/audios/quiz_review.mp3'
import { useQuizStore } from '../../../../stores';

interface IComponents {
    [key: string]: Component
}
const components: IComponents = {
    'mca': QuizMutipleChoice,
    'sca': QuizMutipleChoice,
    'gap': QuizFillInBlank
}
const { question } = defineProps<{
    question: AssessmentQuestion
}>()

const quizStore = useQuizStore();


onMounted(() => {
    if (quizStore.questionState?.state === QuestionState.REVIEW) {
        audioManager.play(quizReview, QuizAudioKey.SFX)
    }
})

onBeforeUnmount(() => {
    audioManager.stop(QuizAudioKey.SFX)
})

</script>
<template>
    <Slide direction="left">
        <component :is="components[question.questionType as keyof typeof components]" :question="question" show-answer show-submission disabled></component>
    </Slide>
</template>